export default __webpack_public_path__ + "static/media/AvatarMirko.40c12d62.svg";